/**
 * Square colored badge showing a mock exam grade letter (A〜E).
 */
import { Box } from "@mui/material";
import { FC } from "react";
import { typography } from "@/theme/typography";
import { rounded } from "@/theme/variables";
import { TMockExamGrade } from "@/infrastructure/adapters/mock-exam/mock-exam.types";
import { GRADE_COLORS } from "@/features/mock-exam/components/grade-guide/grade-guide.constants";

type TMockExamGradeBadgeProps = {
  grade: TMockExamGrade;
  /** Badge edge length in px. */
  size?: number;
};

export const MockExamGradeBadge: FC<TMockExamGradeBadgeProps> = ({ grade, size = 32 }) => {
  const { bg, color } = GRADE_COLORS[grade];

  return (
    <Box
      sx={{
        flex: "0 0 auto",
        width: size,
        height: size,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: rounded.xs,
        bgcolor: bg,
        color,
        ...typography.sub16Bold,
      }}
    >
      {grade}
    </Box>
  );
};
